import { writable } from "svelte/store";
export class Cart {
    constructor() {
        this._list = []; // list of product in cart
        this._listWritable = writable([]); // writable list of product in cart
        this._operationCode = ""; // operation code
        this._shopId = ""; // shop id
        this._dateEnd = new Date().getTime(); // end date of operation in timestamp
        this._count = writable(0); // writable product's quantity in the cart
        this.list;
    }
    // To do in initialization =====================
    set operationCode(value) {
        this._operationCode = value;
    }
    set shopId(value) {
        this._shopId = value;
    }
    set dateEnd(value) {
        this._dateEnd = value.getTime();
    }
    cleanLocalStorage() {
        let ls = this.getLocalStorage();
        if (!ls) {
            ls = [];
        }
        ls = ls.filter(e => e.dateEnd >= new Date().getTime());
        this._list = ls;
        this.saveToLocalStorage();
    }
    // ============================================
    get list() {
        // this.loadFromLocalStorage();
        this._listWritable.set(this.loadFromLocalStorage());
        this.count.set(this.loadFromLocalStorage().length);
        return this._listWritable;
    }
    ;
    get count() {
        this._count.set(this.loadFromLocalStorage().length);
        return this._count;
    }
    async setType(product, typeTarget) {
        const index = this.isOnCart(product);
        if (index >= 0) {
            this._list[index].cartType = typeTarget;
            this.saveToLocalStorage();
            return this.list;
        }
    }
    setSize(product, txt) {
        const index = this.isOnCart(product);
        if (index >= 0) {
            this._list[index].size = txt;
            this.saveToLocalStorage();
            return this.list;
        }
    }
    setModel(product, txt) {
        const index = this.isOnCart(product);
        if (index >= 0) {
            this._list[index].model = txt;
            this.saveToLocalStorage();
            return this.list;
        }
    }
    getProduct(id) {
        return this._list.find(e => e.uid === id);
    }
    async add(product, quantity, cartType) {
        let title = product.name;
        let applicablePromoQty = 0;
        let nbLot = 0;
        let x = 0;
        let y = 0;
        if (Object.getOwnPropertyNames(product).indexOf("Brand") >= 0) {
            let p = product;
            title = p.name + " " + p.brand;
        }
        if (Object.getOwnPropertyNames(product).indexOf("applicablePromoQty") >= 0) {
            let p = product;
            applicablePromoQty = p.applicablePromoQty;
        }
        if (Object.getOwnPropertyNames(product).indexOf("nbLot") >= 0) {
            let p = product;
            nbLot = p.nbLot;
        }
        if (Object.getOwnPropertyNames(product).indexOf("x") >= 0) {
            let p = product;
            x = p.x;
        }
        if (Object.getOwnPropertyNames(product).indexOf("y") >= 0) {
            let p = product;
            y = p.y;
        }
        let cartProduct = {
            uid: product.uid,
            operationCode: this._operationCode,
            shopId: this._shopId,
            quantity: quantity,
            cartType: cartType,
            price: product.price,
            originePrice: product.price,
            name: title,
            size: "",
            model: "",
            dateEnd: this._dateEnd,
            meca: product.meca,
            applicablePromoQty: applicablePromoQty,
            nbLot: nbLot,
            x: x,
            y: y,
        };
        this.addCartProduct(cartProduct);
        return this.list;
    }
    async remove(product, quantity = 1) {
        this.removeCartProduct(product, quantity);
        return this.list;
    }
    setApplicablePromo(product, qty) {
        const index = this.isOnCart(product);
        if (index >= 0) {
            this._list[index].applicablePromoQty = qty;
            this.saveToLocalStorage();
            // this.list;
        }
    }
    // PRIVATE ========================================================
    isOnCart(p) {
        return this._list.findIndex(e => e.uid === p.uid && e.shopId === p.shopId && e.operationCode === p.operationCode);
    }
    addCartProduct(product) {
        const index = this.isOnCart(product);
        if (index >= 0) {
            this._list[index].quantity = this._list[index].quantity + product.quantity;
            this._list[index].price = product.price;
            this._list[index].nbLot = product.nbLot;
            this._list[index].x = product.x;
            this._list[index].y = product.y;
        }
        else {
            this._list.push(product);
        }
        this.saveToLocalStorage();
    }
    removeCartProduct(product, quantity = 1) {
        const index = this.isOnCart(product);
        if (index >= 0) {
            if (this._list[index].quantity > quantity) {
                this._list[index].quantity = this._list[index].quantity - quantity;
                this._list[index].price = product.price;
                this._list[index].nbLot = product.nbLot;
                this._list[index].x = product.x;
                this._list[index].y = product.y;
            }
            else {
                this._list.splice(index, 1);
            }
            this.saveToLocalStorage();
        }
    }
    saveToLocalStorage() {
        localStorage.setItem('oneCatalog', JSON.stringify(this._list));
    }
    loadFromLocalStorage() {
        // let ls = this.getLocalStorage();
        let ls = this._list;
        if (!ls) {
            ls = [];
        }
        ls = ls.filter(e => e.operationCode === this._operationCode);
        ls = ls.filter(e => e.shopId === this._shopId);
        // this._list = ls;
        return ls;
    }
    getLocalStorage() {
        return JSON.parse(localStorage.getItem('oneCatalog'));
    }
}
